import { createTRPCReact } from '@trpc/react-query'
import { httpBatchLink, splitLink } from '@trpc/client'
import superjson from 'superjson'
import type { AppRouter } from '@weapps/campaign-runtime-backend/router'
import { readSsoIdToken } from './lib/sso'

export const trpc = createTRPCReact<AppRouter>()

const apiBase = import.meta.env.VITE_CAMPAIGN_API_URL || ''

function authHeaders() {
  const token = readSsoIdToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export const trpcClient = trpc.createClient({
  transformer: superjson,
  links: [
    splitLink({
      // Front-door reads/opens are anonymous (/public); the effect uses the
      // end-user session (/private).
      condition: () => Boolean(readSsoIdToken()),
      true: httpBatchLink({ url: `${apiBase}/private/trpc`, headers: authHeaders }),
      false: httpBatchLink({ url: `${apiBase}/public/trpc`, headers: authHeaders }),
    }),
  ],
})
